import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {StrainReportModel} from "@app/strain/common/models/strain-report.model";
import {StrainMeasurement} from "@app/strain/common/models/strain-registry-measurement.model";
import {AuthenticationService} from "@app/authentication/services/authentication.service";

@Component({
    selector: 'app-strain-measurement-result-card',
    templateUrl: './strain-measurement-result-card.component.html',
    styleUrls: ['./strain-measurement-result-card.component.scss']
})
export class StrainMeasurementResultCardComponent implements OnInit {

    @Input() measurement: StrainMeasurement;

    @Output() reportClick = new EventEmitter<any>();
    @Output() reportDelete = new EventEmitter<any>();

    constructor(private authService: AuthenticationService) {
    }

    ngOnInit() {
    }

    onReportClick(data: any) {
        this.reportClick.emit({
            measurementId: this.measurement.id,
            report: data.report,
            reportType: data.reportType
        });
    }

    onDeleteReport(report: StrainReportModel) {
        this.reportDelete.emit(report);
    }

    hasPermission() {
        return this.authService.hasPermission('MANAGE_STRAIN_REGISTRY');
    }
}
